import { MutationTree } from 'vuex';
import { BlacklistsState } from './types';

export const mutations: MutationTree<BlacklistsState> = {
    setBlacklists:(state, data) => {
        state.blacklists = data
    },
    setBlackListItem:(state, data) => {
        state.blacklistItem = data
    },
    setBlacklistContacts:(state, data) => {
        state.blacklistContacts = data
    },
    setBlacklistContactsMore:(state, data) => {
        state.blacklistContacts = state.blacklistContacts.concat(data)
    },
    setBlackListContactItem:(state, data) => {
        state.blacklistContactItem = data
    },
};
